import React, { useState } from 'react';
import Layout from '../../components/ui/Layout';
import SubHeader from '../../components/ui/SubHeader';
import ActionBoxes from '../../components/ui/ActionBoxes';
import MetricCard from './components/MetricCard';
import ChartWidget from './components/ChartWidget';
import FilterPanel from './components/FilterPanel';
import SavedReportsPanel from './components/SavedReportsPanel';
import ExportPanel from './components/ExportPanel';
import ComparisonWidget from './components/ComparisonWidget';
import ScheduledReportsPanel from './components/ScheduledReportsPanel';
import QuickActionToolbar from '../../components/ui/QuickActionToolbar';
import OverviewActionsModal from './components/OverviewActionsModal';
import PropertiesActionsModal from './components/PropertiesActionsModal';
import ClientsActionsModal from './components/ClientsActionsModal';
import RevenueActionsModal from './components/RevenueActionsModal';
import PerformanceActionsModal from './components/PerformanceActionsModal';





const ReportingAndAnalyticsDashboard = () => {
  const [activeFilters, setActiveFilters] = useState({
    dateRange: 'last_30_days',
    propertyType: 'all',
    location: 'all',
    staffMember: 'all'
  });
  const [activeView, setActiveView] = useState('overview');
  const [showNewContractModal, setShowNewContractModal] = useState(false);
  const [showOverviewModal, setShowOverviewModal] = useState(false);
  const [showPropertiesModal, setShowPropertiesModal] = useState(false);
  const [showClientsModal, setShowClientsModal] = useState(false);
  const [showRevenueModal, setShowRevenueModal] = useState(false);
  const [showPerformanceModal, setShowPerformanceModal] = useState(false);
  const [selectedProperty, setSelectedProperty] = useState(null);

  // Add handler functions before they are used
  const handleExport = (options) => {
    console.log('Exporting report with options:', options);
    const format = options?.format || 'pdf';
    alert(`جاري تصدير التقرير بصيغة ${format?.toUpperCase()}...`);
  };

  const handleScheduleReport = () => {
    console.log('Scheduling report');
    alert('جدولة التقرير - قريباً');
  };

  const handlePrintReport = () => {
    console.log('Printing report');
    window.print();
  };

  // Analytics action boxes
  const analyticsActions = [
    {
      id: 'overview',
      icon: 'BarChart3',
      label: 'نظرة عامة',
      color: '#3B82F6',
      bgGradient: 'linear-gradient(135deg, rgba(59, 130, 246, 0.2) 0%, rgba(96, 165, 250, 0.25) 100%)',
      borderColor: 'rgba(59, 130, 246, 0.5)',
      onClick: () => {
        setActiveView('overview');
        setShowOverviewModal(true);
      }
    },
    {
      id: 'properties',
      icon: 'Building2',
      label: 'تقارير العقارات',
      color: '#10B981',
      bgGradient: 'linear-gradient(135deg, rgba(16, 185, 129, 0.2) 0%, rgba(52, 211, 153, 0.25) 100%)',
      borderColor: 'rgba(16, 185, 129, 0.5)',
      onClick: () => {
        setActiveView('properties');
        setShowPropertiesModal(true);
      }
    },
    {
      id: 'clients',
      icon: 'Users',
      label: 'تقارير العملاء',
      color: '#F59E0B',
      bgGradient: 'linear-gradient(135deg, rgba(245, 158, 11, 0.2) 0%, rgba(251, 191, 36, 0.25) 100%)',
      borderColor: 'rgba(245, 158, 11, 0.5)',
      onClick: () => {
        setActiveView('clients');
        setShowClientsModal(true);
      }
    },
    {
      id: 'revenue',
      icon: 'Banknote',
      label: 'تقارير الإيرادات',
      color: '#EF4444',
      bgGradient: 'linear-gradient(135deg, rgba(239, 68, 68, 0.2) 0%, rgba(248, 113, 113, 0.25) 100%)',
      borderColor: 'rgba(239, 68, 68, 0.5)',
      onClick: () => {
        setActiveView('revenue');
        setShowRevenueModal(true);
      }
    },
    {
      id: 'performance',
      icon: 'TrendingUp',
      label: 'تقارير الأداء',
      color: '#8B5CF6',
      bgGradient: 'linear-gradient(135deg, rgba(139, 92, 246, 0.2) 0%, rgba(167, 139, 250, 0.25) 100%)',
      borderColor: 'rgba(139, 92, 246, 0.5)',
      onClick: () => {
        setActiveView('performance');
        setShowPerformanceModal(true);
      }
    },
    {
      id: 'export',
      icon: 'Download',
      label: 'تصدير التقرير',
      color: '#06B6D4',
      bgGradient: 'linear-gradient(135deg, rgba(6, 182, 212, 0.2) 0%, rgba(34, 211, 238, 0.25) 100%)',
      borderColor: 'rgba(6, 182, 212, 0.5)',
      onClick: () => handleExport({ format: 'pdf' })
    },
    {
      id: 'schedule',
      icon: 'Clock',
      label: 'جدولة تقرير',
      color: '#EC4899',
      bgGradient: 'linear-gradient(135deg, rgba(236, 72, 153, 0.2) 0%, rgba(244, 114, 182, 0.25) 100%)',
      borderColor: 'rgba(236, 72, 153, 0.5)',
      onClick: handleScheduleReport
    },
    {
      id: 'print',
      icon: 'Printer',
      label: 'طباعة',
      color: '#14B8A6',
      bgGradient: 'linear-gradient(135deg, rgba(20, 184, 166, 0.2) 0%, rgba(45, 212, 191, 0.25) 100%)',
      borderColor: 'rgba(20, 184, 166, 0.5)',
      onClick: handlePrintReport
    }
  ];

  const kpiMetrics = [
    {
      title: 'إجمالي العقارات',
      value: '٢٤٥',
      change: '+١٢.٤٪',
      changeType: 'positive',
      icon: 'Building2',
      trend: [45, 52, 48, 65, 72, 68, 85]
    },
    {
      title: 'العملاء النشطون',
      value: '٤٨٩',
      change: '+٨.٣٪',
      changeType: 'positive',
      icon: 'Users',
      trend: [55, 58, 62, 59, 68, 72, 75]
    },
    {
      title: 'العقود المكتملة',
      value: '٥٦',
      change: '+١٦.٧٪',
      changeType: 'positive',
      icon: 'FileCheck',
      trend: [40, 45, 48, 52, 58, 62, 70]
    },
    {
      title: 'معدل التحويل',
      value: '٦٨٪',
      change: '-٣.٢٪',
      changeType: 'negative',
      icon: 'TrendingUp',
      trend: [75, 72, 70, 68, 69, 67, 68]
    },
    {
      title: 'الإيرادات الشهرية',
      value: '٣٤٥,٠٠٠ د.إ',
      change: '+١٠.٦٪',
      changeType: 'positive',
      icon: 'Banknote',
      trend: [50, 55, 58, 62, 68, 75, 82]
    },
    {
      title: 'متوسط قيمة العقد',
      value: '٦,١٦١ د.إ',
      change: '+٥.٤٪',
      changeType: 'positive',
      icon: 'Receipt',
      trend: [60, 62, 58, 65, 68, 70, 72]
    }
  ];

  const propertyPerformanceData = [
    { name: 'يناير', value: 45 },
    { name: 'فبراير', value: 52 },
    { name: 'مارس', value: 48 },
    { name: 'أبريل', value: 65 },
    { name: 'مايو', value: 72 },
    { name: 'يونيو', value: 68 },
    { name: 'يوليو', value: 85 }
  ];

  const revenueByTypeData = [
    { name: 'شقق', value: 145000 },
    { name: 'فلل', value: 98000 },
    { name: 'مكاتب', value: 67000 },
    { name: 'محلات', value: 35000 }
  ];

  const clientAcquisitionData = [
    { name: 'الأسبوع ١', value: 12 },
    { name: 'الأسبوع ٢', value: 18 },
    { name: 'الأسبوع ٣', value: 15 },
    { name: 'الأسبوع ٤', value: 22 }
  ];

  const handleApplyFilters = (filters) => {
    setActiveFilters(filters);
    console.log('Applying filters:', filters);
  };

  const handleResetFilters = (resetFilters) => {
    setActiveFilters(resetFilters);
    console.log('Resetting filters');
  };

  const handleLoadReport = (report) => {
    console.log('Loading report:', report);
  };

  const handleDeleteReport = (reportId) => {
    console.log('Deleting report:', reportId);
  };

  const handleSaveReport = (reportName) => {
    console.log('Saving report:', reportName);
    alert('تم حفظ التقرير بنجاح');
  };

  const handleChartExport = (chartName) => {
    console.log('Exporting chart:', chartName);
    alert(`جاري تصدير ${chartName}...`);
  };

  const handleChartFullscreen = (chartName) => {
    console.log('Fullscreen chart:', chartName);
    alert(`عرض ${chartName} في وضع ملء الشاشة`);
  };

  const handleAddSchedule = (schedule) => {
    console.log('Adding schedule:', schedule);
  };

  const handleDeleteSchedule = (scheduleId) => {
    console.log('Deleting schedule:', scheduleId);
  };

  return (
    <Layout
      userRole="admin"
      userName="أحمد محمد"
      onQuickMenuToggle={() => console.log('Quick menu toggled')}
    >
      <SubHeader pageTitle="التقارير والتحليلات" />
      <ActionBoxes 
        actions={analyticsActions} 
        showNewContractModal={showNewContractModal}
        setShowNewContractModal={setShowNewContractModal}
        contractTypeConfig={{}}
      />
      <div className="min-h-screen bg-background p-4 md:p-6 lg:p-8">
        
        <QuickActionToolbar actions={analyticsActions} userRole="admin" />

        <div className="grid grid-cols-1 lg:grid-cols-4 gap-4 md:gap-6">
          <div className="lg:col-span-1 space-y-4 md:space-y-6">
            <FilterPanel 
              onApplyFilters={handleApplyFilters}
              onReset={handleResetFilters}
              onFilterChange={handleApplyFilters}
            />
            
            <SavedReportsPanel
              onLoadReport={handleLoadReport}
              onDeleteReport={handleDeleteReport}
            />

            <ExportPanel onExport={handleExport} />

            <ScheduledReportsPanel
              onAddSchedule={handleAddSchedule}
              onDeleteSchedule={handleDeleteSchedule}
            />
          </div>

          <div className="lg:col-span-3 space-y-4 md:space-y-6">
            <div>
              <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground mb-2">
                لوحة التقارير والتحليلات
              </h1>
              <p className="text-sm md:text-base text-muted-foreground">
                تحليل شامل للأداء والمقاييس الرئيسية للأعمال
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {kpiMetrics?.map((metric, index) => (
                <MetricCard key={index} {...metric} />
              ))}
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6">
              <ChartWidget
                title="أداء العقارات الشهري"
                type="bar"
                data={propertyPerformanceData}
                dataKey="value"
                xAxisKey="name"
                onExport={() => handleChartExport('أداء العقارات الشهري')}
                onFullscreen={() => handleChartFullscreen('أداء العقارات الشهري')}
              />

              <ChartWidget
                title="الإيرادات حسب نوع العقار"
                type="pie"
                data={revenueByTypeData}
                dataKey="value"
                xAxisKey="name"
                colors={[
                  'var(--color-primary)',
                  'var(--color-secondary)',
                  'var(--color-accent)',
                  'var(--color-success)'
                ]}
                onExport={() => handleChartExport('الإيرادات حسب نوع العقار')}
                onFullscreen={() => handleChartFullscreen('الإيرادات حسب نوع العقار')}
              />
            </div>

            <ChartWidget
              title="اكتساب العملاء الجدد"
              type="line"
              data={clientAcquisitionData}
              dataKey="value"
              xAxisKey="name"
              colors={['var(--color-accent)']}
              onExport={() => handleChartExport('اكتساب العملاء الجدد')}
              onFullscreen={() => handleChartFullscreen('اكتساب العملاء الجدد')}
            />

            <ComparisonWidget
              title="مقارنة الأداء"
              currentPeriod="يناير ٢٠٢٦"
              previousPeriod="ديسمبر ٢٠٢٥"
            />

            <div className="bg-card rounded-lg border border-border p-4 md:p-6 shadow-warm">
              <h3 className="text-lg font-heading font-semibold text-foreground mb-4">
                رؤى وتوصيات
              </h3>
              <div className="space-y-4">
                <div className="p-4 bg-success/10 border border-success/20 rounded-lg">
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 rounded-full bg-success/20 flex items-center justify-center flex-shrink-0">
                      <span className="text-success text-lg">✓</span>
                    </div>
                    <div>
                      <h4 className="text-sm font-medium text-foreground mb-1">
                        أداء ممتاز في معدلات التحويل
                      </h4>
                      <p className="text-xs text-muted-foreground">
                        معدل التحويل الحالي أعلى بنسبة ١٦٪ من المتوسط الصناعي. استمر في استراتيجيات المتابعة الحالية.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="p-4 bg-warning/10 border border-warning/20 rounded-lg">
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 rounded-full bg-warning/20 flex items-center justify-center flex-shrink-0">
                      <span className="text-warning text-lg">!</span>
                    </div>
                    <div>
                      <h4 className="text-sm font-medium text-foreground mb-1">
                        فرصة للتحسين في منطقة الشارقة
                      </h4>
                      <p className="text-xs text-muted-foreground">
                        انخفاض في نشاط العقارات بنسبة ٨٪ في الشارقة. يوصى بزيادة الجهود التسويقية في هذه المنطقة.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="p-4 bg-primary/10 border border-primary/20 rounded-lg">
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center flex-shrink-0">
                      <span className="text-primary text-lg">ℹ</span>
                    </div>
                    <div>
                      <h4 className="text-sm font-medium text-foreground mb-1">
                        اتجاه موسمي متوقع
                      </h4>
                      <p className="text-xs text-muted-foreground">
                        بناءً على البيانات التاريخية، من المتوقع زيادة بنسبة ٢٥٪ في الطلب خلال الربع القادم.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <OverviewActionsModal 
        isOpen={showOverviewModal} 
        onClose={() => setShowOverviewModal(false)} 
      />
      <PropertiesActionsModal 
        isOpen={showPropertiesModal} 
        onClose={() => setShowPropertiesModal(false)} 
      />
      <ClientsActionsModal 
        isOpen={showClientsModal} 
        onClose={() => setShowClientsModal(false)} 
      />
      <RevenueActionsModal 
        isOpen={showRevenueModal} 
        onClose={() => setShowRevenueModal(false)} 
      />
      <PerformanceActionsModal 
        isOpen={showPerformanceModal} 
        onClose={() => setShowPerformanceModal(false)} 
      />
    </Layout>
  );
};

export default ReportingAndAnalyticsDashboard;